var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGooglemeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 12,
    d: "M138 140V52c0-8.837-7.163-16-16-16H58.16L22 72.16V140c0 8.837 7.163 16 16 16h84c8.837 0 16-7.163 16-16Zm32-88v88l-32-28V80l32-28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglemeet);
export default __webpack_public_path__ + "static/media/googlemeet.25465645741886255f52e5a0fba77283.svg";
export { ForwardRef as ReactComponent };